import { $support } from './support'

export function t(key: string, payload: { [key: string]: any } = {}): string {
  const str = $support.get()?.messages?.[key] ?? key
  return str.replace(/\$\{(\w+)\}/g, (match, p1) => (payload[p1] != null ? payload[p1] : match))
}
